define([], function() {
    var ASSETS_THEME_IMAGE_PATH = '/assets/images/themes/';

    return {
        generate: function(path) {
            return ONP.config.assetsBaseUrl + '/' + path;
        },

        generateImageUrlForCurrentTheme: function(path) {
            return ONP.config.assetsBaseUrl + ASSETS_THEME_IMAGE_PATH + ONP.theme.name + '/' + path;
        }
    };
});
